export const routes = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "About",
    link: "/about",

    subRoutes: [
      {
        name: "Company Vision & Mission",
        link: "/vision-mission",
      },
      {
        name: "Background",
        link: "/background",
      },
      // {
      //   name: "Company Profile",
      //   link: "/company-profile",
      // },
      {
        name: "Company Information",
        link: "/company-information",
      },
      {
        name: "Composition of Board",
        link: "/composition-board",
      },
      {
        name: "Details Of Shareholding",
        link: "/details-of-shareholding",
      },
      // {
      //   name: "Sponsor Director",
      //   link: "/sponsor-director",
      // },
      {
        name: "Code of Conduct",
        link: "/code-conduct",
      },
      {
        name: "Core Values",
        link: "/core-values",
      },
      {
        name: "Structure, Values & Principles",
        link: "/company-structure",
      },
      {
        name: "Award & Achievements ",
        link: "/award",
      },
      {
        name: "Objective",
        link: "/objective",
      },
      {
        name: "Branch Info",
        link: "/branch-info",
      },
    ],
  },

  {
    name: "Business and Services",
    link: "/services",

    subRoutes: [
      {
        name: "Fire Insurance",
        link: "/fire-insurance",
      },
      {
        name: "Motor Insurance",
        link: "/motor-insurance",
      },
      {
        name: "Marine Insurance",
        link: "/marine-insurance",
      },
      {
        name: "Engineering Insurance",
        link: "/engineering-insurance",
      },
      {
        name: "Miscellaneous Insurance",
        link: "/miscellaneous-insurance",
      },
    ],
  },

  {
    name: "Reports & Financial Statement",
    link: "/reports",

    subRoutes: [
      {
        name: "Chairman's Report",
        link: "/chairman-report",
      },
      {
        name: "Managing Director & CEO’s Roundup",
        link: "/managingDirector-report",
      },
      {
        name: "Director's Report",
        link: "/director-report",
      },
      {
        name: "Auditor's Report",
        link: "/Auditor-report",
      },
      {
        name: "Unsettled Claims",
        link: "/UnsettledClaims",
      },
      {
        name: "Balance Sheet",
        link: "/balance-sheet",
      },

      {
        name: "Profit & Loss Account",
        link: "/profit-loss-account",
      },
      {
        name: "Credit Rating",
        link: "/credit-rating",
      },
      {
        name: "Cash Flow Statement",
        link: "/cash-flow-statement",
      },
      {
        name: "Quarterly & Annual Reports",
        link: "/all-reports",
      },

      {
        name: "From AA",
        link: "/from-aa",
      },
      {
        name: "Status of Compliance of Corporate Governance",
        link: "/CorpGovernance",
      },
      {
        name: "Notice Board",
        link: "/notice-board",
      },
    ],
  },

  {
    name: "Gallery",
    link: "/gallery",

    subRoutes: [
      {
        name: "Company Photos",
        link: "/company-photos",
      },
      {
        name: "Company Event Photos",
        link: "/gallery/event-photos",
      },
      {
        name: "Company Videos",
        link: "/company-videos",
      },
    ],
  },

  {
    name: "Shareholder Info",
    link: "/shareholder",

    subRoutes: [
      {
        name: "Unclaim stock/cash Dividend",
        link: "/shareholder-info/unclaim-stock/cash-dividend",
      },
      {
        name: "Dividend Distribution Policy",
        link: "/shareholder-info/dividend-distribution-policy",
      },
      {
        name: "Dividend Distribution Compliance Report",
        link: "/shareholder-info/dividend-distribution-compliance",
      },
      {
        name: "Notice to the Shareholders/Investors",
        link: "/shareholder-info/Shareholders-Investors-notice",
      },
    ],
  },

  // {
  //   name: "Bancassurance",
  //   link: "/bancassurance",

  //   subRoutes: [
  //     {
  //       name: "About Bancassurance",
  //       link: "/bancassurance/about-bancassurance",
  //     },
  //     {
  //       name: "Bank Login",
  //       link: "/bancassurance/bank-login",
  //     },
  //     {
  //       name: "Product List",
  //       link: "/bancassurance/product-list",
  //     },
  //     {
  //       name: "Sell Insurance",
  //       link: "/bancassurance/sell-insurance",
  //     },
  //     {
  //       name: "Sell History",
  //       link: "/bancassurance/sell-history",
  //     },
  //   ],
  // },

  {
    name: "Career",
    link: "/career",
  },
  {
    name: "Contact Us",
    link: "/contact-us",
  },
];
